function isModuleAcceptableForDeclaration(module) {
	// return True if a log declaration is acceptable for this module.
    const DAY_IN_MILLISECONDS = 1000 * 60 * 60  * 24;
    const date_start = new Date(module.date_start);
    const date_end = new Date(module.date_end);
    const now = new Date();
    const days_since_ended = Math.round((now.getTime() - date_end.getTime()) / DAY_IN_MILLISECONDS);
    const not_yet_started = moment(now).isBefore(moment(date_start));
    if ((days_since_ended >= 30) || not_yet_started) {
        return false;
    }
    const matches = module.uv_name.match(/(^SPE-((?!CLO\d|ING\d|DEV\d|RNCP|INF\d))|^ETN-|-GPEA$)/);
    if (matches != null) {
        return false;
    }
    return true;
}

intra_module.controller('FdtCtrl2', function(
    $scope,
    Activity,
    Log,
    currentModules,
    ngNotify,
    identity,
	hub_api_url
) {
    const me = identity;

    $scope.current_modules = currentModules.filter(isModuleAcceptableForDeclaration);

    $scope.loading = false;
    $scope.errors = [];
    $scope.content = { text: '' };
    $scope.sos_jawa = { value: false };
    $scope.schedules = [];
	$scope.previous_logs_visible = false;
	$scope.previously_declared_hours = 0;
	$scope.previous_logs = [];

	const calendar_clean_days = {
		sameDay: 'LL - [Aujourd\'hui]',
		nextDay: 'LL - [Demain]',
		nextWeek: 'LL',
		lastDay: 'LL - [Hier]',
		lastWeek: 'LL - dddd [dernier]',
		sameElse: 'LL'
	};		
	
	async function fetchSchedules() {
		try {
			const url = `${hub_api_url}/intra/my-elearning-slots`;
			let response = await fetch(url, { credentials: 'include' });
			if (!response.ok) {
				throw new Error("Erreur lors de la récupération des information de l'étudiant.");
			}
			const elearning_slots = await response.json();
			// sort: most recent first
			elearning_slots.sort((a, b) => (a.day > b.day ? -1 : (a.day < b.day ? 1 : 0)));
			
			// Add planned schedules for current run
			for (let slot of elearning_slots) {
				const start = moment(slot.day + ' ' + slot.start);
				const end = moment(slot.day + ' ' + slot.end);
				$scope.schedules.push({
					name: start.calendar(null, calendar_clean_days),
					slot: slot,
					start: start,
					end: end
				});
			}
		} catch (error) {
			ngNotify.set('Erreur lors de la récupération des créneaux !' + error, 'error');
		}
	};

	function generateTimeOptions(start_hour, end_hour) {
		const options = [];
		for (let i = start_hour; i <= end_hour; i++) {
			options.push({
				hour: i,
				label: `${i}h`,
			});
		}
		return options;
	}
	
    const resetFdtParams = function() {
		// Note: when reset, the start and end input fields are disabled until
		// a date has been picked in the calendar. The value set here are
		// just placeholders.
		$scope.previous_logs_visible = false;
        $scope.min_hour = 8;
        $scope.max_hour = 19;
        $scope.module_info = {module: null};
        $scope.schedule_info = {schedule: null};
		$scope.selected_start_hour = null;
		$scope.selected_end_hour = null;
		$scope.start_hour_options = generateTimeOptions(8, 18);
		$scope.end_hour_options = generateTimeOptions(9, 19);
    };

	async function populatePreviousLogs() {
		const selected_slot = $scope.schedule_info.schedule.slot;
		const response = await Log.getDeclarations({
			login: identity.login,
			start: selected_slot.day,
			end: selected_slot.day
		}).$promise;
		const logs = [];
		let total_previously_declared_hours = 0;
		for (let log of response.hits) {
			const start = moment(log.start);
			const end = moment(log.end);
			// on ne compte que les heures entieres, donc on retranche 1H si la premiere est entamée.
			const delta = end.hours() - start.hours() - (start.minutes() > 0 ? 1 : 0);
			const log_hours = delta > 0 ? delta : 0; 
			logs.push({
				start: start,
				end: end,
				start_time: start.format("HH:mm"),
				end_time: end.format("HH:mm"),
				module: log.uv_name,
				log_hours: log_hours
			});
			total_previously_declared_hours += log_hours;
		}
		$scope.previous_logs = logs;
		$scope.previous_logs_visible = true;
		$scope.previously_declared_hours = total_previously_declared_hours;
		$scope.$digest();
	}
	
    $scope.onDayChanged = async function() {
		const start_hour = $scope.schedule_info.schedule.start.hours();
		const end_hour = $scope.schedule_info.schedule.end.hours();
		$scope.start_hour_options = generateTimeOptions(start_hour, end_hour - 1);
		$scope.end_hour_options = generateTimeOptions(start_hour + 1, end_hour);
		await populatePreviousLogs();
    };

	function computeOverlapInMinutes(start_a, end_a, start_b, end_b) {
		// convert into minutes-since-beginning-of-the-day.
		const a1 = start_a.hours() * 60 + start_a.minutes();
		const a2 = end_a.hours() * 60 + start_a.minutes();
		const b1 = start_b.hours() * 60 + start_a.minutes();
		const b2 = end_b.hours() * 60 + start_a.minutes();
		if (a1 >= b2 || b1 >= a2) { // no overlap
			return 0;
		} else if (a1 >= b1 && a2 <= b2) { // a fully included in b
			return a2 - a1;
		} else if (b1 >= a1 && b2 <= a2) { // b fully included in a
			return b2 - b1;
		} else if (b1 >= a1) { 	// left part of b overlap right part of a
			return a2 - b1;
		} else {				// left part of a overlap right part of b
			return b2 - a1;
		}
	}
	
	// append a message to `errors` if a break of 1H between 12h and 14h is not respected.
	// assumption: logs are not overlapping.
	function validateLunchTime(errors, start, end) {
		const lunch_break_min = moment(start).hours(12).minutes(0).seconds(0); // same day, 12:00:00
		const lunch_break_max = moment(start).hours(14).minutes(0).seconds(0); // same day, 14:00:00
		let total_overlap_minutes = computeOverlapInMinutes(start, end, lunch_break_min, lunch_break_max);
		for (let log of $scope.previous_logs) {
			total_overlap_minutes += computeOverlapInMinutes(log.start, log.end, lunch_break_min, lunch_break_max);
		}
		if (total_overlap_minutes > 60) {
			errors.push("Vous devez respecter une pause d'au moins une heure entre 12h et 14h.");
		}
	}

	// append a message to `errors` if [start,end] overlap any previous log.
	function validateOverlap(errors, start, end) {
		for (let log of $scope.previous_logs) {
			if (log.end.isSameOrBefore(start) || log.start.isSameOrAfter(end)) {
				continue;
			}
			errors.push("Votre déclaration chevauche une déclaration précédente.");
			return;
		}
	}

	// append a message to `errors` if total declaration time exceed max e-learning per day.
	function validateTotalTime(errors, start, end) {
		const delta_hours_rounded = end.hours() - start.hours() - (start.minutes() > 0 ? 1 : 0);
		const log_hours = delta_hours_rounded > 0 ? delta_hours_rounded : 0;
		const max_elearning_hours_per_day = 8;
		if ($scope.previously_declared_hours + log_hours > max_elearning_hours_per_day) {
			errors.push(`Le nombre d'heures d'e-learning par jour ne doit pas dépasser ${max_elearning_hours_per_day}.`);
		}
	}

	// Validate form then submit declaration
    $scope.declareLogs = function() {
        const decl_content = $scope.content.text.trim();
		$scope.errors = [];

        if (($scope.module_info.module === null)
			|| (decl_content == '')
			|| ($scope.selected_start_hour === null)
			|| ($scope.selected_end_hour === null)) {
            ngNotify.set('Veuillez remplir tous les champs obligatoires !', 'error');
            return;
        }
		if ($scope.selected_start_hour.hour >= $scope.selected_end_hour.hour) {
			$scope.errors.push("L'heure de fin doit être postérieure à celle de début.");
			ngNotify.set("Veuillez corriger la plage horaire.", "error");
			return;
		}
		
		const day = $scope.schedule_info.schedule.slot.day;
		const start_hour = $scope.selected_start_hour.hour.toLocaleString('en-US', { minimumIntegerDigits: 2 });
		const end_hour = $scope.selected_end_hour.hour.toLocaleString('en-US', { minimumIntegerDigits: 2 });		
		const start = moment(`${day} ${start_hour}:00:00`);
		const end = moment(`${day} ${end_hour}:00:00`);
		const declaration = {
		 	start: start.format('YYYY-MM-D H:mm'),
			end: end.format('YYYY-MM-D H:mm'),
			content: decl_content
		};
		validateOverlap($scope.errors, start, end);
		validateLunchTime($scope.errors, start, end);
		validateTotalTime($scope.errors, start, end);
		if ($scope.errors.length) {
			ngNotify.set("Veuillez corriger la plage horaire.", "error");
			return;
		}
		
		$scope.form_loading = true;
		
        Log.declareLogs({
            module:      $scope.module_info.module.id,
            declaration: declaration,
            sosJawa:     false,
		}).$promise.then(function() {
            ngNotify.set('Vos temps de log ont bien été enregistrés', 'success');
			resetFdtParams();
		}).catch(function(api_error) {
			for (let field in api_error.data) {
				const message = api_error.data[field];
				if (field) {
					$scope.errors.push(`${field}: ${message}`);
				} else {
					$scope.errors.push(message);
				}
			}
			ngNotify.set("Echec de la déclaration.", "error");
		}).finally(function() {
			$scope.form_loading = false;
		});
    };


    resetFdtParams();
    fetchSchedules();
});
